import requset from "utils/request";
import { NOTICE } from "apiurl/index.js";
/* 作者消息列表 */
export function AuthorNotice(params) {
  return requset({
    url: `${NOTICE}/notice/list`,
    method: "GET",
    params
  });
}
/* 设置已读 */
export function noticed(data) {
  return requset({
    url: `${NOTICE}/notice/read`,
    method: "POST",
    data
  });
}
